import { Injectable } from '@angular/core';
import { UzurvRestService } from '@uzurv/rideWss/http';
import { Permission } from '../../models';
import { Observable } from 'rxjs';
import { Deserialize } from 'cerialize';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserService extends UzurvRestService {
  readonly resourceUrl = 'users/';

  constructor() {
    super();
  }

  /**
   * Lists a logged in users' permissions
   *
   * @param userId
   */
  listPermissionsForUser(userId: number): Observable<Array<Permission>> {
    return this.get<Array<Permission>>(`${this.resourceUrl}${userId}/permissions/`).pipe(
      map(response => Deserialize(response, Permission))
    );
  }
}
